import { Button, Grid, Link } from "basis";
import { FC } from "react";
import { ProgressBar } from "../../ProgressBar/ProgressBar";
import styles from "../registration.module.scss";

interface Props {
  steps: number[];
  currentStep: number;
  email: string;
  setScreen: Function;
}

export const AlreadyRegistered: FC<Props> = ({
  steps,
  currentStep,
  email,
  setScreen,
}) => (
  <div className={`${styles.alreadyRegistered}`}>
    <ProgressBar
      data-trackid="progress-bar"
      steps={steps}
      currentStep={currentStep}
      error
    />
    <h1 className="h4">Your details</h1>
    <p className={styles.desktopContent}>
      This email address is already in use.
    </p>

    <p>
      Try logging in with <strong>{email}</strong>, or continue with a different
      email address to create your Latitude ID.
    </p>
    <Grid cols="2" cols-sm="160px 160px" colsGap="8" margin="8 0 0 0">
      <Grid.Item colSpan="0">
        <Link appearance="primary-button" width="100%" href="/" newTab={false}>
          Log in
        </Link>
      </Grid.Item>
      <Grid.Item colSpan="1">
        <Button variant="secondary" onClick={() => setScreen("GetStarted")}>
          Use another email address
        </Button>
      </Grid.Item>
    </Grid>
  </div>
);
